import { Component, ElementRef, HostListener, ViewChild, OnInit, OnDestroy } from '@angular/core';
import { CommonService } from '../../service/common.service';
import {
  LoggedInUserKeys,
  LoggedInUserService,
} from '../../service/logged-in-user.service';
import { AppUsersDto } from '../../model/app-users-dto';
import { HttpStatusCode } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router, NavigationEnd, Event } from '@angular/router';
import { ShowpopupDirective } from '../../directives/showpopup.directive';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { ChangePasswordFormComponent } from '../popup-forms/change-password-form/change-password-form.component';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { HrService } from 'src/app/hr/hr.service';
import { DOMAIN_CONFIG } from 'domain-config';
import { StaffingService } from 'src/app/staffing/staffing.service';
import { AdminService } from 'src/app/admin/admin.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: false
})
export class HeaderComponent implements OnInit, OnDestroy {
  loginUser: AppUsersDto;
  @ViewChild(ShowpopupDirective, { static: false })
  loadPopup!: ShowpopupDirective;
  resetPasswordForm: FormGroup;
  private closeSubscription!: Subscription;
  private routerSubscription!: Subscription; // <-- Added to track route changes
  confirmpassword: string;
  @ViewChild('dropdownElement') dropdownElement: ElementRef;
  
  isStaffingDomain: boolean = false;
  isSidebarOpen: boolean = false;
  isPMBuddyBot: boolean = false;
  selectedMenu = ''; // Keeps track of active menu
  profileImageUrl :string |null = ''
  constructor(
    public readonly _commonServices: CommonService,
    private readonly _loggedInUserService: LoggedInUserService,
    private readonly _toaster: ToastrService,
    private readonly _router: Router,
    private readonly fb: FormBuilder,
    private readonly hrService: HrService,
    private _actRoute: ActivatedRoute,
    private readonly _staffingService :StaffingService,
    private readonly _adminService: AdminService
  ) {
    // Force the component to reload on every route
     this._router.routeReuseStrategy.shouldReuseRoute = () => false;
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.loginUser = this._loggedInUserService.getLoggedInUser(
        LoggedInUserKeys.LOGGED_IN_USER,
      );
      this._commonServices._profileImage.subscribe(res=>{
        console.log('_profileImage value',res);
        this.profileImageUrl = res;
      })
    }, 100);
    
    this.isPMBuddyBot = this._actRoute.snapshot.queryParams['isPMBuddyBot'];
    console.log(this.isPMBuddyBot, 'this.isPMBuddyBot');
    
    this.resetFormCreate();
    const currentDomain = window.location.hostname;
    this.isStaffingDomain = DOMAIN_CONFIG[currentDomain]?.isStaffingDomain === true;

    // --- FIX START ---
    // 1. Check the active menu on initial page load / refresh
    this.setActiveMenu(this._router.url);

    // 2. Subscribe to router changes so it updates if they use back/forward buttons
    this.routerSubscription = this._router.events.pipe(
      filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.setActiveMenu(event.urlAfterRedirects);
    });
    // --- FIX END ---
  }

  ngOnDestroy(): void {
    // Clean up subscriptions to prevent memory leaks
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  // --- NEW METHOD TO DETERMINE SELECTED MENU FROM URL ---
setActiveMenu(url: string) {
  const urlTree = this._router.parseUrl(url);
  const viewParam = urlTree.queryParams['view'];

  // 1. Define strictly allowed menu keys to prevent collisions (like ?view=grid)
  const validMenus = ['home', 'aiMatching', 'upload', 'pmView', 'drives', 'tracker'];

  if (viewParam && validMenus.includes(viewParam)) {
    this.selectedMenu = viewParam;
  } else {
    // 2. Fallback logic: Use exact/strict path matching to prevent false positives
    const pathOnly = url.split('?')[0]; 

    if (pathOnly.match(/\/(home|staffing-landing)($|\/)/)) {
      this.selectedMenu = 'home';
    } 
    else if (pathOnly.match(/\/import-data($|\/)/)) {
      this.selectedMenu = 'upload';
    } 
    else if (pathOnly.match(/\/(ai-matching|mapped-candidate|mapped-candidate-view-profile)($|\/)/)) {
      this.selectedMenu = 'aiMatching'; 
    }  
    else if (pathOnly.match(/\/demand-tracker($|\/)/)) {
      this.selectedMenu = 'tracker';
    }
    else if (pathOnly.match(/\/(drives|staffing-dashboard)($|\/)/)) {
      this.selectedMenu = 'drives';
    } 
    else {
      this.selectedMenu = ''; // No match found
    }
  }
}

  // ... Rest of your existing functions (logOut, resetFormCreate, navigateAndClose, etc) remain exactly the same ...
  
  logOut() {
    this._commonServices.logoutUser().subscribe((response) => {
      if (response.statusCode === HttpStatusCode.Ok) {
        this._toaster.success(response.message, 'info');
        this._loggedInUserService.clearEntireStorage();
        if (this.loginUser.userRole == 'FRACTAL_ADMIN') {
          this._router.navigate([
            this._commonServices.Navigations.USER_SIGN_IN,
          ]);
        } else if (this.loginUser.userRole == 'FRACTAL_HR' || this.loginUser.userRole == 'PROJECT_MANAGER' || this.loginUser.userRole == 'VISITOR') {
          this._router.navigate([
            this._commonServices.Navigations.USER_SIGN_IN,
          ]);
        } else if (this.loginUser.userRole == 'COLLEGE_ADMIN') {
          this._router.navigate([
            this._commonServices.Navigations.COLLEGE_ADMIN_SIGNIN,
          ]);
        } else {
          this._router.navigate([this._commonServices.Navigations.SIGN_IN]);
        }
      }
    });
  }

  isOpen = false;
  togglePopup() {
    this.isOpen = !this.isOpen;
  }
  closeDropdown() {
    this.isOpen = false;
  }

  getUsernameInitials(name: any) {
    const matches = name?.match(/\b(\w)/g);
    return matches?.join('');
  }

  resetFormCreate() {
    this.resetPasswordForm = this.fb.group(
      {
        email: [''],
        oldPassword: ['', [Validators.required]],
        newPassword: ['', [Validators.required, this.passwordValidator]],
        confirmPassword: ['', Validators.required],
      },
      { validators: this.passwordMatchingValidatior },
    );
  }
  passwordMatchingValidatior: ValidatorFn = (
    control: AbstractControl,
  ): ValidationErrors | null => {
    const password = control.get('newPassword');
    const confirmPassword = control.get('confirmPassword');
    return password?.value === confirmPassword?.value
      ? null
      : { notmatched: true };
  };
  openChangePasswordPopup() {
    const hostViewContainerRef = this.loadPopup.viewPopup;

    hostViewContainerRef.clear();

    const componentRef = hostViewContainerRef.createComponent(
      ChangePasswordFormComponent,
    );

    this.closeSubscription = componentRef.instance.close.subscribe(() => {
      this.closeSubscription.unsubscribe();
      hostViewContainerRef.clear();
    });
    this.closeSubscription =
      componentRef.instance.confirmPasswordCheck.subscribe((el) => {
        this.confirmpassword = el;
      });
    componentRef.instance.resetPasswordForm = this.resetPasswordForm;
    if (this.loginUser) {
      componentRef.instance.getLoginEmail = this.loginUser.email;
    }
  }

  passwordValidator(control: AbstractControl): ValidationErrors | null {
    const passwordPattern =
      /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?\d)(?=.*?[!@#$%^&*()_+])[\w!@#$%^&*()_+]{8,}$/;
    if (!passwordPattern.test(control.value)) {
      return { invalidPassword: true };
    }
    return null;
  }

  navToReportedQuestion() {
    this._router.navigate([this._commonServices.Navigations.REPORTED_QUESTION]);
  }

  navToServerHealthCheck() {
    this._router.navigate([
      this._commonServices.Navigations.SERVER_HEALTH_CHECK,
    ]);
  }

  routeToWorkdayFailures() {
    const currentDomain = window.location.hostname;
    const isStaffingDomain =
      DOMAIN_CONFIG[currentDomain]?.isStaffingDomain === true;
    if (isStaffingDomain) {
      this._router.navigate([
        this._commonServices.Navigations.CANDIDATE_WORKDAY_STAFFING_ERRORS,
      ]);
    } else {
      this._router.navigate([
        this._commonServices.Navigations.WORKDAY_FAILURES,
      ]);
    }
  }

  toggleSidebar() {
    this.isSidebarOpen = !this.isSidebarOpen;
    document.body.classList.toggle('overflow-hidden', this.isSidebarOpen); // lock scroll
  }

  closeSidebar() {
    if (!this.isSidebarOpen) return;
    this.isSidebarOpen = false;
    document.body.classList.remove('overflow-hidden');
  }

  navigateAndClose(url: string, menu: string) {
    sessionStorage.removeItem('aiMatchingFiltersForSR_VIEW');
    sessionStorage.removeItem('aiMatchingFiltersForBENCH_VIEW');
    sessionStorage.removeItem('aiMatchingFiltersSrBoxes');
    sessionStorage.removeItem('aiMatchingFiltersBenchBoxes');
    sessionStorage.removeItem('mappedCandidatesFiltersForAllCandidates'); 
    sessionStorage.removeItem('benchStatType');
    sessionStorage.removeItem('queryParams');
    localStorage.removeItem('aiMatchingState:v1:68b7e8a66e967e3aed4b44d2:matching');
    localStorage.removeItem('aiMatchingState:v1:68b7e8a66e967e3aed4b44d2:pm');
    this._staffingService.closeRejectRecommendedPopup();
    this._staffingService.closeBlockCandidatePopup();
    this._staffingService.closeRejectRecommendedPopup();
    this._staffingService.closeJDModal();
    this._staffingService.closeCalculationDetailsModal();

    this.closeSidebar();
    if (this.isStaffingDomain && url === '/drives') {
      url = '/staffing/drives/staffing-dashboard';
    }
    this.selectedMenu = menu;

    // Force the component to reload only for aiMatching and pmView 
    // if (url === '/staffing/ai-matching' &&
    //     (menu === 'aiMatching' || menu === 'pmView')) {

    //   this._router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
    //     this._router.navigate([url], {
    //       queryParams: { view: menu }
    //     });
    //   });
    //   return;
    // }
    
    this._router.navigate([url], {
      queryParams: { view: menu }  
    });

  }

  @HostListener('window:keydown.escape', ['$event'])
  onEsc(_ev: KeyboardEvent) {
    this.closeSidebar();
  }

    canSeeProctoringServer(): boolean {
    return this._adminService.isProctoringServerAllowed();
  }

  navToProctoringServer() {
    this._router.navigate([this._commonServices.Navigations.PROCTORING_SERVER]);
  }
}
